/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import {PRINT_FONT_TO_WEB_FONT, TEXT_ALIGNMENT_STYLES} from './cover.constants';

export class CoverPagePreviewPrint extends Component {
    static get props () {
        return {
            coverPageTextInfo: PropTypes.object.isRequired,
            getCoverPageTextInfo: PropTypes.func.isRequired,
            renderWidth: PropTypes.number.isRequired,
            collectionId: PropTypes.string.isRequired,
            pageTrimSize: PropTypes.string.isRequired,
            startAndEndDate: PropTypes.string
        };
    }

    constructor (props) {
        super(props);
        this.titles = props.coverPageTextInfo.frontCoverPageDetail ? props.coverPageTextInfo.frontCoverPageDetail : [];
        this.screenDpiFont = 72;
        this.defaultTrimSize = '8.5x11';
        this.defaultTemplate = {};
        this.getFieldStyles = this.getFieldStyles.bind(this);
        this.getScaleFactors = this.getScaleFactors.bind(this);
        this.getPageSize = this.getPageSize.bind(this);
    }

    componentDidMount () {
        console.log('Cover is mounting');
        if (this.props.collectionId) {
            console.log('Getting Cover Info');
            this.props.getCoverPageTextInfo(this.props.collectionId);
        }
    }
    // This will sets the scaling factors for fonts and box sizes.
    getScaleFactors (parentContainerWidth=400, collectionTrimSize=this.defaultTrimSize) {
        // Assume Screen Dpi is 72
        const renderingComponentWidth = parentContainerWidth;
        const trimSize = collectionTrimSize.trim();
        const width = parseFloat(trimSize.substring(0, trimSize.indexOf('x')).replace('-', '+'));

        return{scaleFactorX: renderingComponentWidth / width, fontScaleFactor: renderingComponentWidth / (width * this.screenDpiFont)};
    }

    getPageSize (trimSize) {
        // Assume Screen Dpi is 72
        const width = parseFloat(trimSize.substring(0, trimSize.indexOf('x')));
        const height = trimSize.substring(trimSize.indexOf('x') + 1, trimSize.length);
        return ({'width': width * this.screenDpiFont, 'height': height * this.screenDpiFont});
    }

    getFieldStyles (template) {
        let styles = {};
        if (template) {
            // Calculate the font size according to  the container sizes font size will be in pt.

            let newFontColor = template.colorRGB ? template.colorRGB : '0/0/0';
            newFontColor = 'rgb(' + newFontColor.replace(/\//g, ',') + ')';
            const fallBackWebFontFamily = template.fontType ? template.fontType.replace('.ttf', '') : 'emptyFont';
            const webFontFamily = template.fontType ? PRINT_FONT_TO_WEB_FONT[template.fontType] : {fontFamily: fallBackWebFontFamily};
            const textAlign = template.textAlignment ? TEXT_ALIGNMENT_STYLES[template.textAlignment.replace('x-', '')].cssAlign : 'left';

            styles = {
                color: newFontColor,
                fontSize: template.fontSize + 'pt',
                fontFamily: webFontFamily && webFontFamily.fontFamily ? webFontFamily.fontFamily : fallBackWebFontFamily,
                textAlign: textAlign,
                lineHeight: template.fontLeading + 'pt',
                top: template.yPosition * this.screenDpiFont,
                left: template.xPosition * this.screenDpiFont,
                width: template.textBoxWidth * this.screenDpiFont,
                height: template.textBoxHeight * this.screenDpiFont,
                position: 'absolute',
                zIndex: 2,
            };
        }
        return styles;
    }

    /**
     *
     * @param placeHolderText
     * @param template
     * @param title
     * @param field
     * @returns {XML}
     */
    getTextField (template, title) {
        const style = this.getFieldStyles(template);
        const formattedTitle = title.replace(/\n\r?/g, '<br/>');
        return (<h1 style={style} className="cover-text">{ReactHtmlParser(formattedTitle)}</h1>);
    }

    render () {
        const {coverPageTextInfo, activeCollection} = this.props;
        const trimSize = this.props.pageTrimSize ? this.props.pageTrimSize : this.defaultTrimSize;
        const pageSize = trimSize ? this.getPageSize(trimSize) : this.getPageSize(this.defaultTrimSize);
        const titles = coverPageTextInfo.frontCoverPageDetail ? coverPageTextInfo.frontCoverPageDetail : [];
        const transformScale = this.props.renderWidth/pageSize.width;
        const CoverPageStyles = {
            width: pageSize.width,
            height: pageSize.height,
            transform: 'scale(' + transformScale + ')',
            transformOrigin: '0% 0%',
            overflow: 'hidden'
        };
        const coverImageStyles = {
            padding: 0,
            margin: 0,
            top: 0,
            left: 0,
            position: 'absolute',
            width: '100%',
            height: '100%',
            backgroundImage: `url(../../../digitaladmin/images/emptycoverimage.png)`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: '100% auto',
            backgroundPosition: 'center',
            border: '4px solid #ccc',
            overflow: 'hidden'

        };
        const coverImageUrl = coverPageTextInfo.coverPageUrl ? coverPageTextInfo.coverPageUrl : '';
        const mainTitleTemplate = titles[0] ? {...titles[0]} : false;
        const subTitleTemplate = titles[1] ? {...titles[1]} : false;
        const authorTitleTemplate = titles[2] ? {...titles[2]} : false;
        const otherTitleTemplate= titles[3] ? {...titles[3]} : '';
        const mainTitle= coverPageTextInfo.bookTitle ? coverPageTextInfo.bookTitle : 'Untitled Collection';
        const subTitle= coverPageTextInfo.field2 ? coverPageTextInfo.field2 : '';
        const authorTitle= coverPageTextInfo.field3 ? coverPageTextInfo.field3 : '';
        const otherTitle= coverPageTextInfo.field4 ? coverPageTextInfo.field4 : '';

        return (
            <div className="book_cover_component" id="largeCoverContainer">
                <div className="cover-preview-container" style={CoverPageStyles} >
                    <div className="cover-image-holder" style={coverImageStyles} >
                        {coverImageUrl && <img src={coverImageUrl} className="cover-preview-image" style={{width:'100%', height:'100%'}}/>}
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/widgets/CoverPage/CovePreviewPrint.js